const removeNotification = notification => {
  if (!notification || typeof notification.remove !== 'function') {
    return;
  }
  notification.remove();
};

export default removeNotification;
